<template>
    <section>
        <div v-if="$route.meta.isLogin == true" class="bgfixed"></div>
        <div class="login-res-box" :style="$route.meta.isLogin == true ? 'margin-top:13%;' : ''"
             :class="isLimitOut ? 'achieve-limit' : ''">
            <div class="logo" v-if="$route.meta.isLogin == true">
                <img :src="this.channelLogo" />
            </div>
            <i class="iconfont icon-del custom-layout" @click="closeLoginBox" v-if="dialogTyper != -1"></i>
            <el-row>
                <el-col :span="13" v-if="isLimitOut" class="limit-out">
                    <el-col :span="24" class="text-center">
                        <p>{{$t('D306')}}，</p>
                        <p class="p-1">{{$t(searchTip)}}</p>
                    </el-col>
                    <el-col :span="24" class="text-center img">
                        <img src="../assets/svg/limit_out.svg"/>
                    </el-col>
                    <el-col :span="24" class="text-left">
                        <p>{{$t('D307')}}：</p>
                    </el-col>
                    <el-col :span="24" class="benefit">

                        <el-col :span="12">
                            <el-col :span="12">
                                <p>{{$t('PERSON_SEARCH')}}</p>
                            </el-col>
                            <el-col :span="12">
                                <p>{{$t('D308')}} <span class="bigger">10</span> {{$t('D309')}} <img
                                        src="../assets/svg/up.svg"/></p>
                            </el-col>
                        </el-col>
                        <el-col :span="12">
                            <el-col :span="12">
                                <p>{{$t('D311')}}</p>
                            </el-col>
                            <el-col :span="12">
                                <p>{{$t('D308')}} <span class="bigger">5</span> {{$t('D309')}} <img
                                        src="../assets/svg/up.svg"/></p>
                            </el-col>
                        </el-col>
                    </el-col>
                </el-col>
                <el-col :span="isLimitOut ? 11 : 24">
                    <div class="login-head">
                        <div class="wrap_1">
                            <div v-if="login_form.dialogType == 1 || login_form.dialogType == 2" class="item item_1"
                                 ref="headItem2" :class="login_form.dialogType == 1 ? 'active' : ''" :style="{'color':login_form.dialogType == 1 ? channelColor:''
                                 ,'border-bottom':login_form.dialogType == 1 ? '2px solid ' + channelColor:'','margin-left': '0'}"
                                 @mouseenter="$refs.headItem2.style.color = channelColor"
                                 @mouseleave="$refs.headItem2.style.color = (login_form.dialogType == 1 ? channelColor:'#666666')"
                                 @click="changeType(1)"
                            >
                                {{$t('L008')}}
                            </div>
                        </div>
                        <div v-if="login_form.dialogType == 3" class="item item_2">
                            {{$t('L001')}}
                        </div>

                        <div v-if="login_form.dialogType == 4" class="item item_2">
                            {{$t('D348')}}
                        </div>
                    </div>
                    <!-- 登录 -->
                    <div v-if="login_form.dialogType == 1">
                        <el-row class="phone-email">
                            <el-col :span="24">
                                <el-input v-model="login_form.user_name" :placeholder="this.$t('D142')"></el-input>
                            </el-col>
                        </el-row>

                        <el-row class="pwd">
                            <el-col :span="24">
                                <el-input type="password" v-model="login_form.password" autocomplete="new-password"
                                          :placeholder="this.$t('SEARCH_SENTENSE6')"
                                          @keyup.enter.native="loginSubmit"></el-input>
                            </el-col>
                        </el-row>

                      <!--  <el-row>
                            <el-col :span="24">
                                <div class="handle">
                                    <transition name="fade">
                                        <div class="imgBox" v-show="hovering||dragging">
                                            <img class="verImg" :src="imgSrc"/>
                                            <div class="verify" v-show="verify"></div>
                                            <div class="verified" v-show="verified"></div>
                                            &lt;!&ndash; <div class="refreshBox">
                                                     <span class="refresh" @click="refreshImg()"><i class="fa fa-repeat"></i></span>
                                                 </div>&ndash;&gt;
                                        </div>
                                    </transition>
                                    <span class="swiper" :class="wrapperStyle"
                                          @mouseenter="handleMouseEnter"
                                          @mouseleave="handleMouseLeave"
                                          @mousedown="onButtonDown"
                                          @touchstart="onButtonDown"
                                    >
                                <i class="fa fa-angle-double-right" v-if="!this.login_form.identifyCode"></i>
                                <i class="fa fa-check-circle-o"
                                   :style="{'color':channelColor}"
                                   v-if="this.login_form.identifyCode"></i>
                            </span>
                                    <span class="text">{{$t('L011')}}</span>
                                </div>
                            </el-col>
                        </el-row>-->

                        <el-row>
                            <el-col :span="24" class="login-cookie">
                                <el-checkbox v-model="login_form.maintainLogin">{{$t('D391')}}</el-checkbox>
                            </el-col>
                        </el-row>


                        <el-row class="btn-cus">
                            <el-col :span="24">
                                <el-button type="primary" size="small" class="custom-btn" @click="loginSubmit"
                                           :style="{'background':channelColor,'border-color':channelColor}"
                                           :loading="login_form.btnLoading">{{$t('LOGIN')}}
                                </el-button>
                            </el-col>
                        </el-row>

                        <el-row class="line-bom">
                            <el-col :span="24" style="margin-bottom: 15px;">
                                <div class="line-blk">
                                    <span class="reg" v-if="showLogin" @click="changeType(3)" ref="regis"
                                          :style="{color:channelColor}"
                                          @mouseenter="$refs.regis.style.color = channelColor"
                                          @mouseleave="$refs.regis.style.color = channelColor">{{$t('L018')}}</span>


                                    <span class="fg-pwd" ref="forpwd"
                                          style="float:right;"
                                          :style="!showLogin ? 'margin-left:0;' : ''"
                                          @mouseenter="$refs.forpwd.style.color = channelColor"
                                          @mouseleave="$refs.forpwd.style.color = '#666666'"
                                          @click="$router.push({path:'/forgotPassword'})">{{$t('SETTING_FORGET')}}？</span>
                                </div>
                            </el-col>
                        </el-row>


                    </div>

                    <!-- 注册 -->
                    <div v-if="login_form.dialogType == 3">
                        <el-row class="phone-email">
                            <el-col :span="24">
                                <div class="master-input">
                                    <div class="prepend">
                                        <el-dropdown @command="handleCmd">
										<span class="el-dropdown-link">
                                {{regNames[login_form.nameType]}} <i class="el-icon-arrow-down el-icon--right"></i>
                              </span>
                                            <el-dropdown-menu class="master-input-item" slot="dropdown" v-if="formParams && formParams.registerEmail">
                                                <el-dropdown-item disabled :command="2">{{$t('EMAIL_ADDRESS')}}
                                                </el-dropdown-item>
                                            </el-dropdown-menu>
                                          <el-dropdown-menu class="master-input-item" slot="dropdown" v-else>
                                            <el-dropdown-item :command="2">{{$t('EMAIL_ADDRESS')}}
                                            </el-dropdown-item>
                                          </el-dropdown-menu>
                                        </el-dropdown>

                                    </div>
                                    <input class="p-left" :placeholder="regPlaceHolder[login_form.nameType]"
                                           v-if="formParams && formParams.registerEmail" disabled
                                           v-model="login_form.user_name = formParams.registerEmail"/>
                                    <input class="p-left" :placeholder="regPlaceHolder[login_form.nameType]"
                                           v-else
                                           v-model="login_form.user_name"/>
                                </div>
                            </el-col>
                        </el-row>

                        <el-row>
                            <el-col :span="24">
                                <div class="handle">
                                    <transition name="fade">
                                        <div class="imgBox" v-show="hovering||dragging">
                                            <img class="verImg" :src="imgSrc"/>
                                            <div class="verify" v-show="verify"></div>
                                            <div class="verified" v-show="verified"></div>
                                            &lt;!&ndash; <div class="refreshBox">
                                                     <span class="refresh" @click="refreshImg()"><i class="fa fa-repeat"></i></span>
                                                 </div>&ndash;&gt;
                                        </div>
                                    </transition>
                                    <span class="swiper" :class="wrapperStyle"
                                          @mouseenter="handleMouseEnter"
                                          @mouseleave="handleMouseLeave"
                                          @mousedown="onButtonDown"
                                          @touchstart="onButtonDown"
                                    >
                                 <i class="fa fa-angle-double-right" v-if="!this.login_form.identifyCode"></i>
                                 <i class="fa fa-check-circle-o"
                                    :style="{'color':channelColor}"
                                    v-if="this.login_form.identifyCode"></i>
                            </span>
                                    <span class="text">{{$t('L011')}}</span>
                                </div>
                            </el-col>
                        </el-row>

                        <el-row class="validation-code">
                            <el-col :span="24">
                                <div class="master-input">
                                    <input class="p-right" :placeholder="this.$t('SEARCH_SENTENSE10')"
                                           v-model="login_form.identify"/>
                                    <div class="append" v-loading="login_form.codeLoading">
                                        <p @click="send_code" :style="{'color':channelColor}" v-show="!show">
                                            {{$t('D145')}}</p>
                                        <p v-show="show">{{count}} s</p>
                                    </div>
                                </div>
                            </el-col>
                        </el-row>

                        <el-row class="pwd-register">
                            <el-col :span="24">
                                <el-input type="password" v-model="login_form.password"
                                          :placeholder="this.$t('SEARCH_SENTENSE6')"
                                          @keyup.enter.native="registerSubmit"></el-input>
                            </el-col>
                        </el-row>

                        <el-row v-if="false">
                            <el-col :span="24" class="login-cookie">
                                <el-checkbox v-model="login_form.allowProtocol">{{$t('L005')}}</el-checkbox>
                            </el-col>
                        </el-row>

                        <el-row class="btn-cus">
                            <el-col :span="24">
                                <el-button type="primary" size="small" class="custom-btn"
                                           :style="{'background':channelColor,'border-color':channelColor}"
                                           :loading="register_loding" @click="registerSubmit">{{$t('L006')}}
                                </el-button>
                            </el-col>
                        </el-row>

                        <el-row class="line-bom">
                            <el-col :span="24" style="margin-bottom: 15px;">
                                <div class="line-blk">
                                    <span class="reg" ref="bk_login"
                                          @mouseenter="$refs.bk_login.style.color = channelColor"
                                          @mouseleave="$refs.bk_login.style.color = '#666666'" @click="changeType(1)">{{$t('L007')}}</span>
                                </div>
                            </el-col>
                        </el-row>

                    </div>
                    <!-- 绑定 -->
                    <div v-if="login_form.dialogType == 4">
                        <el-row class="phone-email">
                            <el-col :span="24">
                                <div class="master-input">
                                    <div class="prepend">
                                        <div class="el-dropdown">
                                       <span class="el-dropdown-link">
                                           {{regNames[login_form.nameType]}}
                                        </span>
                                        </div>
                                        <!-- <el-dropdown @command="handleCmd">
                                          <span class="el-dropdown-link">
                                            {{regNames[login_form.nameType]}}
                                             &lt;!&ndash;<i class="el-icon-arrow-down el-icon&#45;&#45;right"></i>&ndash;&gt;
                                         </span>
                                              <el-dropdown-menu class="master-input-item" slot="dropdown">
                                                  <el-dropdown-item :command="1">{{$t('L002')}}</el-dropdown-item>
                                                  <el-dropdown-item :command="2" >{{$t('D147')}}</el-dropdown-item>
                                              </el-dropdown-menu>
                                         </el-dropdown>-->
                                    </div>
                                    <input class="p-left" :placeholder="regPlaceHolder[login_form.nameType]"
                                           v-model="login_form.user_name"/>
                                </div>
                            </el-col>
                        </el-row>
                      
                        <el-row class="btn-cus">
                            <el-col :span="24">
                                <el-button type="primary" size="small" @click="bindSubmit" class="custom-btn"
                                           :style="{'background':channelColor,'border-color':channelColor}"
                                           :loading="login_form.btnLoading">{{$t('D256')}}
                                </el-button>
                            </el-col>
                        </el-row>

                    </div>
                </el-col>
            </el-row>
        </div>
    </section>
</template>
<script>
import {
  checkSlide,
  requestLogin,
  sendRegSendCode,
  checkUserName,
  sendMessage,
  regUser,
  dynamicLogin,
  bindContact,
  getSocialBindUrl,
  ipCountry
} from "../api/api";
import * as types from "../store/types";

    import unreadMsgMixin from '@/mixin/unreadMsgMixin'

    export default {
        name: 'LoginV2Dialog',
        components: {},
        mixins: [unreadMsgMixin],
        data() {
            return {
              ip_isCn: true,
                imgSrc: '',
                imgList: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14],
                verify: true,
                verified: true,
                verX: 0,
                drag: false,
                dragging: false,
                hovering: false,
                startX: 0,
                currentX: 0,
                __v_t: [],
                disabled: false,
                dialogVisible: false,
                show_register: false,
                register_loding: false,
                show: false,
                count: '',
                timer: null,
                regNames: {
                    1: this.$t('L002'),
                    2: this.$t('D147')
                },
                regPlaceHolder: {
                    1: this.$t('D144'),
                    2: this.$t('D146')
                },
                login_form: {
                    dialogType: 1,
                    nameType: 2,
                    user_name: '',
                    password: '',
                    identify: '',
                    identifyCode: '',
                    maintainLogin: false,
                    allowProtocol: false,
                    btnLoading: false,
                    codeLoading: false,
                    invitedId: '',

                },
                channelLogo: require('./../assets/logo_white.png'),
                channelColor: '',
            }
        },
        computed: {
            wrapperStyle() {
                if (this.drag) {
                    return 'dragging';
                } else if (this.hovering) {
                    return 'hovering'
                } else {
                    return '';
                }
            },
            showLogin() {
                var customSettings = window.localStorage.getItem('customSettings');
                var logoUrl = '';
                var channelColor = '';
                if (customSettings) {
                    customSettings = JSON.parse(customSettings);
                    if (customSettings.logo) {
                        return false;
                    }
                }
                if (this.channelColor != ''
                    && this.channelColor != undefined
                    && this.channelColor != "undefined") {
                    return false;
                }
                return true;
            }
        },
        props: {
            formParams: {},
            dialogTyper: {
                type: Number,
                default: -1
            },
            nameTyper: {
                type: Number,
                default: 2
            },
            invitedIdGard: {
                type: String,
                default: ''
            },
            searchTip: {},
            isLimitOut: {
                type: Boolean,
                default: false,
            }
        },
        methods: {
            handleCmd(name) {
                this.login_form.nameType = name;
            },
            bindSubmit(ev) {
                if (this.login_form.user_name == '') {
                    return false;
                }
                this.login_form.user_name = this.login_form.user_name.trim();
                if (this.login_form.nameType == 1) {
                    let regPhone =  /^[0-9,+]*$/;
                    if (!regPhone.test(this.login_form.user_name)) {
                        this.$message.error(this.$t('D302'));
                        return false;
                    }
                } else if (this.login_form.nameType == 2) {
                    let reg = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
                    if (!reg.test(this.login_form.user_name)) {
                        this.$message.error(this.$t('PLS_INPUT_RIGHT_EMAIL'));
                        return false;
                    }
                }
                if (this.login_form.identifyCode == '') {
                    this.$message.error(this.$t('L011'));
                    return false;
                }
                /*if (this.login_form.identify == '') {
                    this.$message.error(this.$t('PLS_INPUT_VALIDATE_CODE'));
                    return false;
                }*/
      /* if (this.login_form.allowProtocol == false) {
                     this.$message.error(this.$t('D301'));
                     return false;
                 }*/
      let param = this.login_form;
      this.login_form.btnLoading = true;
      bindContact(param)
        .then(res => {
          this.login_form.btnLoading = false;
          if (res.data.ret == 0) {
            this.$emit("closeDialog", true);
            this.$emit("asycNameType", this.login_form.user_name);
            this.restoreLoginForm();
            this.$message.success(this.$t(res.data.data));
          } else {
            //  this.$router.push({path: '/register_tip'});
            // this.resetVerify();
            this.login_form.identifyCode = "";
            this.$message.error(this.$t(res.data.msg));
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    registerSubmit(ev) {
      if (this.login_form.user_name == "") {
        if (this.login_form.nameType == 1) {
          return this.$message.error(this.$t("D144"));
        }

        if (this.login_form.nameType == 2) {
          return this.$message.error(this.$t("D146"));
        }
      }
      this.login_form.user_name = this.login_form.user_name.trim();
      if (this.login_form.nameType == 1) {
        let regPhone = /^1[0-9][0-9]{9}$/;
        if (!regPhone.test(this.login_form.user_name)) {
          this.$message.error(this.$t("D302"));
          return false;
        }
      } else if (this.login_form.nameType == 2) {
        let reg = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
        if (!reg.test(this.login_form.user_name)) {
          this.$message.error(this.$t("PLS_INPUT_RIGHT_EMAIL"));
          return false;
        }
      }
      if (this.login_form.identifyCode == '') {
        this.$message.error(this.$t('L011'));
        return false;
      }
      if (this.login_form.identify == '') {
        this.$message.error(this.$t('PLS_INPUT_VALIDATE_CODE'));
        return false;
      }
      if (this.login_form.password == "") {
        this.$message.error(this.$t("PLS_INPUT_PWD"));
        return false;
      }
      if (
        this.login_form.password.length < 8 ||
        this.login_form.password.length > 20
      )
        return this.$message.error(this.$t("D304"));
      /*if (this.login_form.allowProtocol == false) {
                    this.$message.error(this.$t('D301'));
                    return false;
                }*/
      if (window.localStorage.getItem("invitedId")) {
        this.login_form.invitedId = window.localStorage.getItem("invitedId");
      }
      let param = this.login_form;
      if (this.$route.query.activationId) {
        param.activationId = this.$route.query.activationId;
      }
      this.register_loding = true;
      let c_name = "registered"; // cookie 名称
      let val = "xieco"; // cookie 要存的值
      // 获取cookie
      /*
      let get_name = encodeURIComponent(c_name) + "=";
      let cookieStart = document.cookie.indexOf(get_name);
      let get_val = null;
      if (cookieStart > -1) {
        let cookieEnd = document.cookie.indexOf(";", cookieStart);
        if (cookieEnd == -1) {
          cookieEnd = document.cookie.length;
        }
        get_val = decodeURIComponent(
          document.cookie.substring(cookieStart + get_name.length, cookieEnd)
        );
        if (get_val === val) {
          this.$message.warning(this.$t("_B13168073E9CA5E8"));
          this.register_loding = false;
          return;
        }
      }*/
      let reg_from = window.sessionStorage.getItem('reg_from')
      if(reg_from) {
        param.reg_from = reg_from
      }
      regUser(param)
        .then(res => {
          this.register_loding = false;
          if (res.data.ret == 0) {
            let exdate = new Date();
            exdate.setDate(exdate.getDate() + 30);
            document.cookie =
              c_name + "=" + escape(val) + ";expires=" + exdate.toGMTString();
            this.$store.commit(types.LOGIN, res.data.data.token);
            this.restoreLoginForm();
            this.$emit("get-user-info");
            this.$emit("closeDialog", true);
            window.localStorage.removeItem("invitedId");
                  if (this.$route.query.redirect) {
                        this.$router.push({
                            path: this.$route.query.redirect
                        })
                    }
                    if (this.$route.meta.isLogin == true) {
                        this.$router.push({
                            path: '/member/account'
                        })
                    }
                  } else {
                      //  this.$router.push({path: '/register_tip'});
                      this.resetVerify();
                      this.login_form.identifyCode = '';
                      this.$message.error(this.$t(res.data.msg));
                  }
                }).catch(error => {
              console.log(error);
          })
      },
      send_code() {
        if (this.login_form.user_name == '') {
          return this.$message.error(this.$t("D146"));
          return false;
        }
        this.login_form.user_name = this.login_form.user_name.trim();
        if (this.login_form.nameType == 1) {
            let regPhone = /^1[0-9][0-9]{9}$/;
            if (!regPhone.test(this.login_form.user_name)) {
                this.$message.error(this.$t('D302'));
                return false;
            }
        } else if (this.login_form.nameType == 2) {
            let reg = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
            if (!reg.test(this.login_form.user_name)) {
                this.$message.error(this.$t('PLS_INPUT_RIGHT_EMAIL'));
                return false;
            }
        }
        if (this.login_form.identifyCode == '') {
            this.$message.error(this.$t('L011'));
            return false;
        }
        let param = this.login_form;
        param.lang = this.$store.state.language;
        this.login_form.codeLoading = true;
        checkUserName(param).then(res => {
            let ret = res.data;
            if (ret.ret == -1 && param.dialogType != 2 && param.dialogType != 4) {
                this.$message.error(this.$t('D315'));
                this.login_form.codeLoading = false;
            } else {
                let param = this.login_form;
                if (this.login_form.nameType == 1) {
                    sendMessage(param).then(res => {
                        this.login_form.codeLoading = false;
                        let ret = res.data;
                        if (ret.ret == 0) {
                            this.getCode();
                            this.$message.info(this.$t('SEND_SUCCEED'));
                        } else {
                            this.$message.error(this.$t(ret.msg));
                        }
                    }).catch(error => {
                        console.log(error);
                    })
                } else if (this.login_form.nameType == 2) {
                    sendRegSendCode(param).then(res => {
                        this.login_form.codeLoading = false;
                        let ret = res.data;
                        if (ret.ret == 0) {
                            this.getCode();
                            this.$message.info(this.$t('SEND_SUCCEED'));
                        } else {
                            this.$message.error(this.$t(ret.msg));
                        }
                    }).catch(error => {
                        console.log(error);
                    })
                }
            }
        }).catch(error => {
            console.log(error);
        });
    },
    getCode() {
      const TIME_COUNT = 60;
      if (!this.timer) {
          this.count = TIME_COUNT;
          this.show = true;
          this.timer = setInterval(() => {
              if (this.count > 0 && this.count <= TIME_COUNT) {
                  this.count--;
              } else {
                  this.show = false;
                  clearInterval(this.timer);
                  this.timer = null;
              }
          }, 1000)
      }
    },
    restoreLoginForm() {
        this.login_form = {
            nameType: this.login_form.nameType,
            user_name: '',
            password: '',
            identify: '',
            identifyCode: '',
            maintainLogin: false,
            allowProtocol: false,
            btnLoading: false,
            codeLoading: false,
            dialogType: this.login_form.dialogType,
            invitedId: ''
        };
        //this.resetVerify();
    },
    dynamicLoginFunc() {
        if (this.login_form.user_name == '') {
            this.$message.error(this.$t('D144'));
            return false;
        }
//                if (this.login_form.identifyCode == '') {
//                    this.$message.error(this.$t('L011'));
//                    return false;
//                }
        this.login_form.user_name = this.login_form.user_name.trim();
        let loginParams = this.login_form;
        this.login_form.btnLoading = true;
        dynamicLogin(loginParams).then(res => {
            this.login_form.btnLoading = false;
            if (res.data.ret === 0) {
                this.$store.commit(types.LOGIN, res.data.data.token);
                this.restoreLoginForm();
                this.$emit('get-user-info')
                this.$emit('closeDialog', true)
                if (this.$route.query.redirect) {
                    this.$router.push({
                        path: this.$route.query.redirect
                    })
                }
                if (this.$route.meta.isLogin == true) {
                    this.$router.push({
                        path: '/member/account'
                    })
                }
            } else {
                //this.resetVerify();
                this.login_form.identifyCode = '';
                this.$message.error(this.$t(res.data.msg));
            }
        })
    },
    loginSubmit(ev) {
        if (this.login_form.user_name == '') {
            this.$message.error(this.$t('D142'));
            return false;
        }
        if (this.login_form.password == '') {
            this.$message.error(this.$t('PLS_INPUT_PWD'));
            return false;
        }
//                if (this.login_form.identifyCode == '') {
//                    this.$message.error(this.$t('L011'));
//                    return false;
//                }
        this.login_form.user_name = this.login_form.user_name.trim();
        this.login_form.btnLoading = true;
        var loginParams = this.login_form;
        requestLogin(loginParams).then(res => {
            this.login_form.btnLoading = false;
            if (res.data.ret === 0) {
                this.$store.commit(types.LOGIN, res.data.data.token);
                this.restoreLoginForm();
                this.$emit('get-user-info')
                this.$emit('closeDialog', true)
                if (this.$route.name === 'inlandDetail') {
                    location.href = this.$route.path
                }
                if (this.$route.query.redirect) {
                    this.$router.push({
                        path: this.$route.query.redirect
                    })
                }
                if (this.$route.meta.isLogin == true) {
                    this.$router.push({
                        path: '/member/account'
                    })
                }
                // 获取到未读消息数量
                this.unreadCount()
            } else {
                //this.resetVerify();
                this.login_form.identifyCode = '';
                this.$message.error(this.$t(res.data.msg))
              }
        }).catch(error => {

            //this.loginMsg(error)
        });
    },
    changeType(type) {
        if (this.login_form.dialogType == type) {
            return;
        } else {
            this.restoreLoginForm();
            if (type == 2) {
                this.login_form.nameType = 1;
            } else {
                this.login_form.nameType = 2;
            }
            this.login_form.dialogType = type;
            this.$emit('synchronousVar', this.login_form.dialogType, this.login_form.nameType);
        }
    },
    doSend() {
        this.dialogVisible = !this.dialogVisible;
        /*ga('send', 'event', 'Search', 'play', 'Login_v2');
        ga('send', 'event', 'Register', 'success', 'register');*/
    },
    handleMouseEnter() {
      if (!this.dragging && !this.hovering && !this.login_form.identifyCode) {
        this.refreshImg();
      }
      this.hovering = true;
    },
    handleMouseLeave() {
      this.hovering = false;
    },
    onButtonDown(event) {
      if (this.disabled || this.login_form.identifyCode) return;
      this.drag = true;
      event.preventDefault();
      this.onDragStart(event);
      window.addEventListener("mousemove", this.onDragging);
      window.addEventListener("touchmove", this.onDragging);
      window.addEventListener("mouseup", this.onDragEnd);
      window.addEventListener("touchend", this.onDragEnd);
      window.addEventListener("contextmenu", this.onDragEnd);
    },
    onDragStart(event) {
      this.dragging = true;
      if (event.type === "touchstart") {
        event.clientX = event.touches[0].clientX;
      }
      this.startX = event.clientX;
      let text = this.$el.getElementsByClassName("text")[0];
      text.style.opacity = 0;
    },
    onDragging(event) {
      if (this.dragging) {
        let diff = 0;
        if (event.type === "touchmove") {
          event.clientX = event.touches[0].clientX;
        }
        this.currentX = event.clientX;
        diff = this.currentX - this.startX;
        let winW = 300;
        if (diff < 0) {
          diff = 0;
        } else if (diff > winW) {
          diff = winW;
        }
        if (diff >= 0 && diff <= winW) {
          this.__v_t.push([diff, new Date().getTime()]);
        }
        let swiper = this.$el.getElementsByClassName("swiper")[0];
        let verify = this.$el.getElementsByClassName("verify")[0];
        swiper.style.left = `${diff}px`;
        verify.style.left = `${diff + 10}px`;
      }
    },
    onDragEnd() {
      if (this.dragging) {
        /*
                     * 防止在 mouseup 后立即触发 click，导致滑块有几率产生一小段位移
                     * 不使用 preventDefault 是因为 mouseup 和 click 没有注册在同一个 DOM 上
                     */
        setTimeout(() => {
          this.dragging = false;
          this.drag = false;
          let stopL = this.currentX - this.startX + 10;
          // 误差在2px以内则算做成功
          if (Math.abs(stopL - this.verX) > 2) {
            this.resetVerify();
            this.__v_t = [];
            this.$message.error(this.$t("D317"));
          } else {
            let params = {};
            params._type = this.login_form.dialogType;
            params.__v_t = this.__v_t;
            this.disabled = true;
            checkSlide(params).then(res => {
              this.disabled = false;
              if (res.data && res.data.ret === 0) {
                this.login_form.identifyCode = res.data.data;
                this.$message.success(this.$t("D316"));
              } else {
                this.$message.error(this.$t("D317"));
              }
            });
          }
        }, 0);
        window.removeEventListener("mousemove", this.onDragging);
        window.removeEventListener("touchmove", this.onDragging);
        window.removeEventListener("mouseup", this.onDragEnd);
        window.removeEventListener("touchend", this.onDragEnd);
        window.removeEventListener("contextmenu", this.onDragEnd);
      }
    },
    resetVerify() {
      //解除绑定，并将滑动模块归位
      let swiper = this.$el.getElementsByClassName("swiper")[0];
      let verify = this.$el.getElementsByClassName("verify")[0];
      let text = this.$el.getElementsByClassName("text")[0];
      swiper.style.left = "0px";
      verify.style.left = "10px";
      text.style.opacity = 1;
    },
    refreshImg() {
      let swiper = this.$el.getElementsByClassName("swiper")[0];
      let verify = this.$el.getElementsByClassName("verify")[0];
      let text = this.$el.getElementsByClassName("text")[0];
      let verified = this.$el.getElementsByClassName("verified")[0];
      let verImg = this.$el.getElementsByClassName("verImg")[0];
      // 随机生成下标
      swiper.style.left = "0px";
      verify.style.left = "10px";
      text.style.opacity = 1;
      let index = Math.round(Math.random() * 13);
      this.verify = true;
      this.verified = true;
      let imgUrl = `/static/img/slide/${this.imgList[index]}.png`;
      this.imgSrc = imgUrl;
      verify.style["background-image"] = `url(${imgUrl})`;
      // 获取图片高度
      let imgH = verImg.clientHeight;
      // 随机生成坐标（图片框固定宽度为300px，高度不定）
      let verX = 150 * (1 + Math.random()) - 38,
        verY = imgH / 4 + (Math.random() * imgH) / 2;
      // 30为模块宽度
      verify.style.display = "block";
      verify.style.top = `${verY}px`;
      verify.style["background-position"] = `-${verX}px -${verY}px`;
      verified.style.display = "block";
      verified.style.left = `${verX}px`;
      verified.style.top = `${verY}px`;
      this.verX = verX;
    },
    closeLoginBox() {
      this.restoreLoginForm();
      // this.login_form.dialogType = 1;
      this.$emit("closeDialog", true);
    },
    isUrl(str) {
      //特殊案例
      if (str == "static/img/channel/huisuanzhang.png") {
        return true;
      } else {
        return !!str.match(
          /(((^https?:(?:\/\/)?)(?:[-;:&=\+\$,\w]+@)?[A-Za-z0-9.-]+|(?:www.|[-;:&=\+\$,\w]+@)[A-Za-z0-9.-]+)((?:\/[\+~%\/.\w-_]*)?\??(?:[\*-\+=&;%@.\w_]*)#?(?:[\w]*))?)$/g
        );
      }
    },
    setCustomSetting() {
      return false
      this.channelColor = decodeURIComponent(this.$route.query.color);
      let customSettings = {};
      if (this.$route.query.logo != undefined) {
        this.channelLogo = this.$route.query.logo;
        if (this.isUrl(this.channelLogo)) {
          customSettings.logo = this.channelLogo;
        }
      }
      customSettings.color = this.channelColor;
      let lc = location.href;
      if (this.$route.meta.isLogin == true) {
        window.localStorage.setItem(
          "customSettings",
          JSON.stringify(customSettings)
        );
      }

      //如果是dd域名
      if (
        (lc.indexOf("search.tenms.cn") !== -1 ||
          lc.indexOf("www.tenms.cn") !== -1) &&
        top.location == location
      ) {
        window.localStorage.removeItem("customSettings");
        this.channelLogo = require("./../assets/logo_white.png");
        this.channelColor = "";
      }
    },
    socialBind(platform_id) {
      getSocialBindUrl({
        platform_id: platform_id,
        lang: this.$store.state.language
      }).then(res => {
        if (res.data.ret == 0) {
          location.href = res.data.data;
        }
      });
    }
  },
  watch: {
    formParams: {
      handler(curVal, oldVal) {
        this.login_form.dialogType = curVal.dialogTyper;
        this.login_form.nameType = curVal.nameTyper;
        this.login_form.invitedId = curVal.invitedIdGard;
      },
      deep: true
    },
    dialogTyper: {
      handler(curVal, oldVal) {
        if (curVal !== -1) {
          this.login_form.dialogType = curVal;
        }
      },
      deep: true
    },
    nameTyper: {
      handler(curVal, oldVal) {
        if (curVal !== -1) {
          this.login_form.nameType = curVal;
        }
      },
      deep: true
    },
    invitedIdGard: {
      handler(curVal, oldVal) {
        if (curVal !== -1) {
          this.login_form.invitedId = curVal;
        }
      },
      deep: true
    },
    "$i18n.locale"(val) {
      this.regNames = {
        1: this.$t("L002"),
        2: this.$t("D147")
      };
      this.regPlaceHolder = {
        1: this.$t("D144"),
        2: this.$t("D146")
      };
    }
  },
  created() {
    ipCountry().then(res => {
      this.ip_isCn = res.data.ret === 0 ? true : false;
    });
    this.login_form.dialogType = this.$route.query.dialogType || 1
  },
  mounted() {
    this.login_form.invitedId = this.$route.params.invitedId;
    //记住邀请人id
    window.localStorage.setItem("invitedId", this.login_form.invitedId);
    //this.__v_t = new Array();

    this.setCustomSetting();

    if (
      window.localStorage.getItem("token") &&
      this.$route.meta.isLogin == true
    ) {
      this.$router.push({ path: "/" });
    }

    // 随机添加背景图
    // this.refreshImg();
    /* if(window.ga){
                ga('set', {
                    page: '/login',
                    title: '登录'
                });
                ga('send', 'pageview');
            }*/
  }
};
</script>
<style lang="less" scoped>
@import "../styles/common.less";

.bgfixed {
  background-size: cover !important;
  background: url("/static/img/index/login-bg-new.jpg") !important;
  background-position: center 0 !important;
  height: 100%;
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
}

.box {
  width: 300px;
  padding: 20px;
  background-color: #fff;
  box-shadow: 2px 2px 8px 0 rgba(0, 0, 0, 0.4);
}

.imgBox {
  position: absolute;
  width: 337px;
  height: 203px;
  overflow: hidden;
  box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.4);
  top: -216px;
  left: 0;
  background: white;
  z-index: 9;
}

.imgBox img {
  width: 100%;
}

.handle {
  display: flex;
  align-items: center;
  position: relative;
  height: 38px;
  margin: 17px 0;
  padding: 4px 0 4px 70px;
  /*box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.2) inset;*/
  user-select: none;
  background: #f3f3f3;
  border: 1px solid #ebebeb;
  border-radius: 2px;
}

.text {
  opacity: 1;
  transition: opacity 0.5s ease-in-out;
  color: #aaa;
}

.swiper {
  position: absolute;
  left: 0;
  top: -1px;
  width: 38px;
  height: 38px;
  background: #ffffff;
  /*        box-shadow: 2px 2px 6px 0 rgba(0, 0, 0, 0.2);*/
  border: 1px solid #cccccc;
  line-height: 32px;
  text-align: center;
  font-size: 20px;
  color: #cccccc;
  &.hovering {
    cursor: pointer;
    .imgBox {
      display: block;
    }
  }
  &.dragging {
    cursor: pointer;
  }
  .fa-check-circle-o {
    color: #005CAF;
  }
}

.verify {
  position: absolute;
  left: 10px;
  width: 43px;
  height: 43px;
  border-radius: 5px;
  background-repeat: no-repeat;
  background-attachment: scroll;
  background-size: 337px;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.4), 0 0 10px 0 rgba(90, 90, 90, 0.8);
  z-index: 10;
}

.verified {
  position: absolute;
  width: 43px;
  height: 43px;
  border-radius: 5px;
  background-color: rgba(0, 0, 0, 0.1);
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.8) inset;
}

.refreshBox {
  border-top: 1px solid #ccc;
  position: absolute;
  z-index: 1111111111;
  right: 0;
  top: 0;
  display: block;
}

.refresh {
  color: #fff;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  padding: 8px 20px;
  border-radius: 20px;
  background: transparent;
  transition: all 0.5s ease-in-out;
  font-size: 20px;
}

.refresh.click {
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.4) inset;
}

.login-res-box {
  position: relative;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  margin: 0 auto;
  background: #fff;
  box-shadow: 0 1px 4px 0 #cccccc;
  border-radius: 4px;
  margin-bottom: 50px;
  width: 404px;
  padding: 33px;
  margin-top: 10%;
  .logo {
    position: absolute;
    top: -75px;
    left: 0;
    right: 0;
    margin: auto;
    text-align: center;

    img {
      height: 64px !important;
    }
  }
  &.achieve-limit {
    width: 808px;
  }
  .limit-out {
    font-size: 12px;
    color: #666666;
    padding-right: 33px;
    padding-top: 21px;
    .bigger {
      font-weight: bold;
    }
    .p-1 {
      margin-top: 8px;
    }
    .img {
      margin-top: 31px;
      margin-bottom: 31px;
    }
    .benefit {
      margin-top: 18px;
    }
  }
  .custom-layout {
    position: absolute;
    right: 17px;
    top: 16px;
    cursor: pointer;
    z-index: 10;
    color: #999999;
  }
  .login-head {
    .wrap_1 {
      width: 100%;
      text-align: center;
    }
    .item {
      font-size: 18px;
      color: #666666;
      letter-spacing: 0;
      display: inline-block;
      &.item_1 {
        cursor: pointer;
        &:hover {
          color: #005CAF;
        }
        &.active {
          color: #005CAF;
          border-bottom: 2px solid #005CAF;
        }
        &:last-child {
          margin-left: 60px;
        }
      }
      &.item_2 {
        width: 100%;
        text-align: center;
      }
    }
  }
  .phone-email {
    margin-top: 34px;
  }
  .pwd {
    margin: 17px 0;
  }
  .pwd-register {
    margin: 17px 0;
  }
  .custom-btn {
    width: 340px;
    height: 32px;
    background: #005CAF;
    border-radius: 4px;
    margin-top: 33px;
    font-size: 14px;
    line-height: 1px;
  }
  .val-code {
    margin: 17px 0;
  }
  .line-bom {
    margin-top: 20px;
    .line-blk {
      font-size: 12px;
      color: #666666;
      span {
        &.reg {
          color: #005CAF;
        }
        cursor: pointer;
        &.res {
          color: #005CAF;
        }
        &:hover {
          color: #005CAF;
        }
        &.login {
          float: right;
          .fa-weixin {
            color: #62b900;
            font-size: 18px;
            float: left;
            margin-right: 5px;
          }
        }
        &.fg-pwd {
          margin-left: 20px;
        }
      }
    }
  }
}

.login-validation-code {
  margin: 17px 0;
}
.validation-code {
  margin-top: 17px;
}

.reg_pwd {
  margin: 17px 0;
}
</style>



// WEBPACK FOOTER //
// login.vue?53d6fdbe